import {
  OPEN_MODAL,
} from "./actions.type";
import {
  SET_HAS_OPEN_MODAL,
} from "./mutations.type";

const state = {
  hasOpenModal: false,
};

const getters = {
  hasOpenModal(state) {
    return state.hasOpenModal;
  },
};

const actions = {
  [OPEN_MODAL]({ commit }, value) {
    commit(SET_HAS_OPEN_MODAL, value);
  },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [SET_HAS_OPEN_MODAL](state, value) {
    state.hasOpenModal = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
